import {
  PRODUCT_FAMILY_SA,
  PRODUCT_FAMILY_DEALSHIELD,
  SELLER_ASSURANCE_PRODUCT_TYPE,
  getProductType,
} from './productFamily';

export { PRODUCT_FAMILY_SA as SA_PRODUCT_CODE } from './productFamily';
export const BUYER_SUBSCRIPTION_TYPE = 'BUYER';
export const SELLER_SUBSCRIPTION_TYPE = 'SELLER';
// SELLER_PAID is a DS (buyer-owned, seller-paid) subscription type. It shares the
// DS/buyer-side slot with BUYER; SELLER stays reserved for SA products.
export const SELLER_PAID_SUBSCRIPTION_TYPE = 'SELLER_PAID';

// DS/buyer-side subscription types (as opposed to the SA-side SELLER type).
export const DS_SUBSCRIPTION_TYPES = [
  BUYER_SUBSCRIPTION_TYPE,
  SELLER_PAID_SUBSCRIPTION_TYPE,
];

export const isDsSubscriptionType = type => DS_SUBSCRIPTION_TYPES.includes(type);

// Human-readable labels for display. Unknown values fall back to a simple
// title-case so nothing renders blank.
export const SUBSCRIPTION_TYPE_LABELS = {
  [BUYER_SUBSCRIPTION_TYPE]: 'Buyer',
  [SELLER_SUBSCRIPTION_TYPE]: 'Seller',
  [SELLER_PAID_SUBSCRIPTION_TYPE]: 'Seller Paid',
};

export const formatSubscriptionType = type => {
  if (!type) return '';
  return (
    SUBSCRIPTION_TYPE_LABELS[type]
    || type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
  );
};

// Subscription-type options offered when creating a DS subscription.
export const DS_SUBSCRIPTION_TYPE_OPTIONS = [
  {
    key: BUYER_SUBSCRIPTION_TYPE,
    text: SUBSCRIPTION_TYPE_LABELS[BUYER_SUBSCRIPTION_TYPE],
    value: BUYER_SUBSCRIPTION_TYPE,
  },
  {
    key: SELLER_PAID_SUBSCRIPTION_TYPE,
    text: SUBSCRIPTION_TYPE_LABELS[SELLER_PAID_SUBSCRIPTION_TYPE],
    value: SELLER_PAID_SUBSCRIPTION_TYPE,
  },
];

export const resolveProductFamily = record => {
  const { productFamily, subscriptionType, productName } = record || {};
  const family = typeof productFamily === 'string' ? productFamily.trim().toUpperCase() : '';
  if (family) {
    return family === PRODUCT_FAMILY_SA ? PRODUCT_FAMILY_SA : PRODUCT_FAMILY_DEALSHIELD;
  }
  if (subscriptionType === SELLER_SUBSCRIPTION_TYPE) return PRODUCT_FAMILY_SA;
  if (isDsSubscriptionType(subscriptionType)) return PRODUCT_FAMILY_DEALSHIELD;
  if (getProductType(productName) === SELLER_ASSURANCE_PRODUCT_TYPE) return PRODUCT_FAMILY_SA;
  return PRODUCT_FAMILY_DEALSHIELD;
};
